const options = {
    EloquaSiteID: "1294",
    EloquaScript: "//img.en25.com/i/elqCfg.min.js",
    LookupIdVisitor: "82fb0c8fa2c341ac915afd1f6b4e2702",
    LookupIdPrimary: "ddbbcf3eff0a4852979ca8d2f22d3770",
    VisitorUniqueField: "V_ElqEmailAddress",
    PrimaryUniqueField: "C_EmailAddress",
    EloquaFormID: "2016-Master-Form-Campaign"
};
/* eslint-disable no-undef */
const setFormValues = () => ({
    first_name: GetElqContentPersonalizationValue("C_FirstName"),
    last_name: GetElqContentPersonalizationValue("C_LastName"),
    email: GetElqContentPersonalizationValue("C_EmailAddress"),
    company: GetElqContentPersonalizationValue("C_Company"),
    role: GetElqContentPersonalizationValue("C_Role1"),
    country: GetElqContentPersonalizationValue("C_Country"),
    phone: GetElqContentPersonalizationValue("C_BusPhone"),
    institutionSize1: GetElqContentPersonalizationValue("C_Institution_Size1"),
    howDidYouHearAboutUs1: GetElqContentPersonalizationValue("C_howDidYouHearAboutUs1")
});
/* eslint-enable no-undef */

// TODO FIXME XXX This appends a couple scripts to the dom everytime it's executed. Need a cleaner solution => move pre-pop data to global store.
/**
 * Tries to perform am Eloqua lookup using the Eloqua cookie. If successful it will pre-populate the form with the looked up values.
 * Adapted from http://mediarolls.com/DLPrepop/DLPrepop.html
 *
 * @returns {Promise} Promise that resolves to object of pre-pop values
 */
export const prePopulateEloquaData = () =>
    new Promise((resolve, reject) => {
        /* eslint-disable no-underscore-dangle */
        const onReady = () => {
            // try to reference the _elqQ object that gets loaded into the global namespace
            const { _elqQ } = window;
            if (!_elqQ) {
                const err = "There was an issue communicating with Eloqua";
                // TODO Log errors console.warn(err);
                reject(err);
            }
            _elqQ.push(["elqSetSiteId", options.EloquaSiteID]);
            _elqQ.push(["elqTrackPageView"]);
            // LOOKUP A:  Eloqua Visitor Data Lookup from Cookie  -  Ensure VisitorUniqueField is pulled in the Profile View
            _elqQ.push(["elqDataLookup", escape(options.LookupIdVisitor), ""]);
        };
        /* eslint-enable no-underscore-dangle */

        // load the eloqua script then begin calling functions that rely on it
        const async_load = () => {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = options.EloquaScript;
            s.onreadystatechange = () => onReady();
            s.onload = () => onReady();
            const x = document.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
        };

        async_load();

        let FirstLookup = true;

        // expose to global namespace so Eloqua can call it
        window.SetElqContent = () => {
            /* eslint-disable no-underscore-dangle */
            if (FirstLookup) {
                // LOOKUP B:  Eloqua Contact/DataCard/Prospect/Company Data Lookup from Email Address
                window._elqQ.push([
                    "elqDataLookup",
                    escape(options.LookupIdPrimary),
                    /* eslint-disable no-undef */
                    `
                        <${options.PrimaryUniqueField}>
                        ${GetElqContentPersonalizationValue(options.VisitorUniqueField)}
                        </${options.PrimaryUniqueField}>
                    `
                    /* eslint-enable no-undef */
                ]);
                FirstLookup = false;
            } else {
                // This is triggered the after Lookup B fires.  LoadFields starts the field prepoulation process.
                const formValues = setFormValues();
                resolve(formValues);
            }
            /* eslint-enable no-underscore-dangle */
        };
    });

export default prePopulateEloquaData;
